import React from "react";
import Map from 'ol/Map';

const MapContext = React.createContext<Map | undefined>(undefined);

export default MapContext;
